import { Subscription } from 'rxjs';
import { StatesService } from './../../services/states.service';
import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { IOrder } from '../../interfaces/order';

@Component({
  selector: 'dash-orderslist',
  templateUrl: './orderslist.component.html',
  styleUrls: ['./orderslist.component.scss']
})
export class OrderslistComponent implements OnInit {

  private subscription: Subscription;
  public ordersList: IOrder[] = [];
  public loading: boolean;
  public dateSetup: any;

  constructor(private _orderService: OrderService,
    private _stateService: StatesService) { 
    this.loading = true;
  }

  transformDate(date){
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(); // hoje
    const secondDate = new Date(date); // data que vem da lista
    const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay));
    return diffDays;
  }

  ngOnInit(): void {
    this.subscription = this._stateService.currentDate.subscribe(res => {
      this.dateSetup = res;
      this._orderService.lastSixOrders(this.dateSetup.start_date, this.dateSetup.end_date).subscribe(data => {
        this._stateService.changeRecentSixOrders(data);
        this._stateService.currentSixOrders.subscribe(res => {
          this.ordersList = res.orders;
          this.loading = false;
        });
      });
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
